import React, { useState } from "react";
import s from "./EventItem.module.css";
import { IEvent } from "../../../services/models/event";
import sButtons from "../../../assets/styles/buttons.module.css";
import { toast } from "react-toastify";
import stylesInputs from "../../../assets/styles/inputs.module.css";
import { EventModalUpdate } from "../EventModal/EventModalUpdate";
import { Role } from "../../../services/models/role";
import { convertDateTimeFormat } from "../../../Utils/convertDate";

interface EventsItemProps {
    item: IEvent;
    isAdministrator: boolean;
    roles?: Role[];
}

export const EventItem: React.FC<EventsItemProps> = ({ item, isAdministrator, roles = [] }) => {
    const handleCopyLink = (e: React.MouseEvent) => {
        e.stopPropagation();
        let url = item.link;
        if (!/^https?:\/\//i.test(url)) {
            url = "https://" + url;
        }
        navigator.clipboard.writeText(url);
        toast.success("Ссылка скопирована!");
    };

    const handleLinkClick = () => {
        let url = item.link;
        if (!/^https?:\/\//i.test(url)) {
            url = "https://" + url;
        }
        window.open(url, "_blank");
    };
    const [modalShow, setModalShow] = useState(false);

    return (
        <div className={`d-flex flex-column ${s.wrapper}`}>
            <div className={s.content}>
                <div className={s.header}>
                    <p className={s.dateTime}>{convertDateTimeFormat(item.dateTime)}</p>
                    <div className={s.infoBlock}>
                        {isAdministrator && (
                            <div className={s.roleWrapper}>
                                {item?.guestRoles &&
                                    item.guestRoles?.map((role) => (
                                        <p key={role.id} className={s.role}>
                                            {role.name}
                                        </p>
                                    ))}
                            </div>
                        )}
                        <div className={s.tagsWrapper}>
                            {item?.eventTags &&
                                item.eventTags?.map((tag, index) => (
                                    <p key={index} className={s.tag}>
                                        {tag}
                                    </p>
                                ))}
                        </div>
                    </div>
                </div>
                <h3 className={s.title}>{item.name}</h3>
            </div>
            <div className={`${stylesInputs.mainInput} ${s.linkWrapper}`} onClick={handleCopyLink}>
                <span className={s.linkText}>{item.link}</span>
                <div className={s.copyIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M11.1 22.75H6.9C2.99 22.75 1.25 21.01 1.25 17.1V12.9C1.25 8.99 2.99 7.25 6.9 7.25H11.1C15.01 7.25 16.75 8.99 16.75 12.9V17.1C16.75 21.01 15.01 22.75 11.1 22.75ZM6.9 8.75C3.8 8.75 2.75 9.8 2.75 12.9V17.1C2.75 20.2 3.8 21.25 6.9 21.25H11.1C14.2 21.25 15.25 20.2 15.25 17.1V12.9C15.25 9.8 14.2 8.75 11.1 8.75H6.9Z"
                            fill="#1A64A5"
                        />
                        <path
                            d="M17.1 16.75H16C15.59 16.75 15.25 16.41 15.25 16V12.9C15.25 9.8 14.2 8.75 11.1 8.75H8C7.59 8.75 7.25 8.41 7.25 8V6.9C7.25 2.99 8.99 1.25 12.9 1.25H17.1C21.01 1.25 22.75 2.99 22.75 6.9V11.1C22.75 15.01 21.01 16.75 17.1 16.75ZM16.75 15.25H17.1C20.2 15.25 21.25 14.2 21.25 11.1V6.9C21.25 3.8 20.2 2.75 17.1 2.75H12.9C9.8 2.75 8.75 3.8 8.75 6.9V7.25H11.1C15.01 7.25 16.75 8.99 16.75 12.9V15.25Z"
                            fill="#1A64A5"
                        />
                    </svg>
                </div>
            </div>

            <div className={s.buttons}>
                <button
                    onClick={handleLinkClick}
                    className={`${sButtons.iconButton} ${s.button} ${sButtons.redirectButtonRight}`}
                >
                    Перейти
                </button>
                {isAdministrator && (
                    <button
                        onClick={() => setModalShow(true)}
                        className={`${sButtons.iconButton} ${s.button} ${sButtons.settingsButtonRight} ${sButtons.lightBlueButton}`}
                    >
                        Изменить
                    </button>
                )}
            </div>
            {isAdministrator && (
                <EventModalUpdate
                    roles={roles}
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    currentEvent={item}
                />
            )}
        </div>
    );
};
